<h1 mat-dialog-title>Create a brand domain</h1>

<div mat-dialog-content class="content">
  <div class="target-context" *ngIf="showTargetContext">
    <span class="target-label">Target</span>
    <span class="target-value">{{targetLabel}}</span>
  </div>
  <mat-form-field appearance="outline" class="domain-field">
    <mat-label>Subdomain</mat-label>
    <input matInput [formControl]="newDomain" placeholder="domain-example">
    <span matSuffix>{{suffix}}</span>
  </mat-form-field>
  <div class="preview">Result: {{preview}}</div>
</div>

<div mat-dialog-actions class="buttons">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="newDomain.invalid">Save</button>
  <button mat-button (click)="cancel()">Cancel</button>
</div>
